module.exports = __webpack_public_path__ + "img/Kyrgyzstan.ee4f020f.png";